import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Button from '../../../components/common/Button';
import { close as dispatchClose } from '../../../modules/modal/actions';
import { getWithdrawPage } from '../../../modules/content/selectors';
import backupContent from '../../../../resources/withdrawBackup.json';

export const WithdrawalInfo = ({ close, contentStackContent }) => {
  let content;
  if (contentStackContent) {
    content = contentStackContent;
  } else {
    content = backupContent;
  }
  return (
    <div className="modal modal--zero-padding">
      <div className="withdrawal-info modal__content-scrollable">
        <h3 className="modal__sub-header" dangerouslySetInnerHTML={{ __html: content.infoModal.header }} />
        <p className="modal__paragraph" dangerouslySetInnerHTML={{ __html: content.infoModal.text }} />
      </div>
      <div className="withdrawal-info__footer">
        <Button className="modal__button button--secondary" onClick={close}>
          <span dangerouslySetInnerHTML={{ __html: content.infoModal.buttonText }} />
        </Button>
      </div>
    </div>
  );
};

WithdrawalInfo.propTypes = {
  close: PropTypes.func.isRequired,
  contentStackContent: PropTypes.object
};

const mapDispatchToProps = {
  close: dispatchClose
};

const mapStateToProps = state => ({
  contentStackContent: getWithdrawPage(state)
});

export default connect(mapStateToProps, mapDispatchToProps)(WithdrawalInfo);
